import { memo } from 'react';

type Props = {
  className?: string;
  size?: number;
};

export const Dashboard = memo(({ className, size = 24 }: Props) => (
  <svg
    className={className}
    width={size}
    height={size * 25 / 24}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(3.000000, 5.000000)" stroke="#686868" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <rect x="0" y="0" width="18" height="15" rx="1"></rect>
      </g>
      <g transform="translate(6.000000, 7.000000)" stroke="#2BABDC">
        <circle cx="2.35125" cy="2.35125" r="2.35125"></circle>
        <line x1="2.35125" y1="2.35125" x2="4.1146875" y2="3.526875" strokeLinecap="round"></line>
        <line x1="2.35125" y1="2.35125" x2="2.35125" y2="0.512438449" strokeLinecap="round"></line>
      </g>
      <g transform="translate(6.000000, 14.000000)" stroke="#5A77B5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25">
        <rect x="0" y="0.5" width="5" height="3" rx="1"></rect>
      </g>
      <g transform="translate(14.000000, 14.000000)" stroke="#5A77B5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25">
        <rect x="0" y="0.5" width="4" height="3" rx="1"></rect>
      </g>
      <line x1="15.75" y1="12.75" x2="15.75" y2="9.25" stroke="#5E61A2" strokeWidth="1.5" strokeLinecap="round" transform="translate(15.750000, 11.000000) rotate(-270.000000) translate(-15.750000, -11.000000)" />
      <line x1="15.75" y1="9.75" x2="15.75" y2="6.25" stroke="#5E61A2" strokeWidth="1.5" strokeLinecap="round" transform="translate(15.750000, 8.000000) rotate(-270.000000) translate(-15.750000, -8.000000)" />
    </g>
  </svg>
));

export default Dashboard;